var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isMarketingElementsEmpty
        ? _c("ib-charts-placeholder")
        : _c(
            "el-tabs",
            {
              staticClass: "tabs",
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: { label: _vm.$t("timeline"), name: "first", lazy: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "bg-white pt-4 pb-1" },
                    [
                      _vm.activeTab === "first"
                        ? _c("marketing-budget-over-time", {
                            attrs: { "chart-animations": "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("breakdown"),
                    name: "second",
                    lazy: "",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "bg-white pt-4 pb-1" },
                    [
                      _vm.activeTab === "second"
                        ? _c("distribution-of-marketing-budget", {
                            attrs: { "chart-animations": "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("table"), name: "third", lazy: "" } },
                [
                  _c(
                    "div",
                    { staticClass: "bg-white pt-4 pb-2" },
                    [_c("marketing-budget-table")],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }